import styled from 'styled-components';

const CustomCollapseStyle = styled.div`
	.collapse-enter {
		opacity: 0;
		max-height: 0;
		overflow: hidden;
	}

	.collapse-enter-active {
		opacity: 1;
		max-height: 100vh;
		transition: opacity 500ms, max-height 500ms;
	}

	.collapse-exit {
		opacity: 1;
		max-height: 100vh;
		overflow: hidden;
	}

	.collapse-exit-active {
		opacity: 0;
		max-height: 0;
		transition: opacity 500ms, max-height 500ms;
	}
`;

export default CustomCollapseStyle;
